import Cookies from 'js-cookie'

const TokenKey = 'Shulan-Admin-Token'

export function getToken () {
    return Cookies.get(TokenKey)
}

export function setToken (token) {
    return Cookies.set(TokenKey, token, { expires: 0.5, path: '' })
}

export function removeToken () {
    return Cookies.remove(TokenKey, { path: '' })
}

const username = 'shulan-user'
const password = 'shulan-password'

export function getUserName () {
    return Cookies.get(username)
}
export function getPassword () {
    return Cookies.get(password)
}

export function setUserName (name) {
    return Cookies.set(username, name, { expires: 5 })
}

export function setPassword (pass) {
    return Cookies.set(password, pass, { expires: 5 })
}
